import { render } from "./LocalReportStep3.vue?vue&type=template&id=09cce978&ts=true"
import script from "./LocalReportStep3.vue?vue&type=script&lang=ts"
export * from "./LocalReportStep3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__